"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var document_service_1 = require("../../document.service");
require("rxjs/Rx");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var index_1 = require("../../model/index");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var document_auth_provider_service_1 = require("../../document-auth-provider.service");
var subscription_manager_decorator_1 = require("../../shared/subscription-manager.decorator");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var Download = /** @class */ (function () {
    function Download(documentService, messageService, classifierService, documentAuthService) {
        this.documentService = documentService;
        this.messageService = messageService;
        this.classifierService = classifierService;
        this.documentAuthService = documentAuthService;
        this.isReady = false;
        this._size = null;
        this._name = "";
        this._imageUrl = "";
        this._errorMessage = null;
    }
    Download_1 = Download;
    Download.prototype.ngOnInit = function () {
        this.initAll();
    };
    Download.prototype.ngOnChanges = function (changes) {
        if (changes.documentId && !changes.firstChange) {
            this.initAll();
        }
    };
    Download.prototype.initAll = function () {
        var _this = this;
        if (this.documentId) {
            this.$sm = this.documentService.getIsDocumentPresent(this.documentId).subscribe(function (isPresent) {
                if (isPresent) {
                    _this.initConfirmedDocument();
                }
                else {
                    _this.initTempDocument();
                }
            });
        }
    };
    Download.prototype.initConfirmedDocument = function () {
        var _this = this;
        this.$sm = zip_1.zip(this.documentService.getDocumentInfo(this.documentId), this.documentAuthService.getDocumentAuthInfo(this.categorySystemName, this.entityId, this.documentRootName)).subscribe(function (_a) {
            var info = _a[0], authInfo = _a[1];
            _this.authInfo = authInfo;
            _this.setDocumentInfo(info, authInfo);
        });
    };
    Download.prototype.initTempDocument = function () {
        var _this = this;
        this.$sm = this.documentService.getTempDocumentInfo(this.documentId).subscribe(function (info) {
            _this.setDocumentInfo(info);
        }, function (error) {
            if (error.status === 404) {
                _this._errorMessage = Download_1.FILE_NOT_FOUND;
            }
        });
    };
    Download.prototype.setDocumentInfo = function (info, authInfo) {
        this._documentInfo = info;
        this._userName = this.getUserName(this._documentInfo.userId);
        this._name = this._documentInfo.name;
        this._date = this._documentInfo.created * 1000;
        this._size = +this._documentInfo.size;
        if (this.isImage) {
            this.setImageUrl(authInfo);
        }
        this.isReady = true;
    };
    /*
        TODO confirm changes
    */
    Download.prototype.downloadFile = function () {
        var _this = this;
        this.$sm['download'] = this.documentService.getIsDocumentPresent(this.documentId)
            .subscribe(function (isConfirmed) {
            if (isConfirmed) {
                _this.$sm = _this.documentAuthService
                    .getDocumentAuthInfo(_this.categorySystemName, _this.entityId, _this.documentRootName)
                    .pipe(operators_1.switchMap(function (authInfo) {
                    return _this.documentService.getDownloadUrl(_this.documentId, authInfo);
                })).subscribe(function (url) {
                    return _this.documentService.downloadDocument(url, index_1.FileType.ORIGINAL);
                });
            }
            else
                _this.documentService.downloadTempDocument(_this.documentId);
        });
    };
    Download.prototype.getUserName = function (userId) {
        var _this = this;
        return this.classifierService.loadClassifier("User", userId, false)
            .pipe(operators_1.mergeMap(function (classifier) {
            if (classifier === null || classifier.getId() === null) {
                return of_1.of(null);
            }
            return _this.classifierService.getEntityName("User", classifier);
        }));
    };
    Download.prototype.setImageUrl = function (authInfo) {
        var _this = this;
        var $url = authInfo ?
            this.documentService.getDocumentUrl(this.documentId, this.authInfo, index_1.FileType.THUMBNAIL) :
            this.documentService.getTempDocumentUrl(this.documentId, index_1.FileType.THUMBNAIL);
        this.$sm = $url.subscribe(function (url) {
            _this._imageUrl = url;
        });
    };
    Object.defineProperty(Download.prototype, "sizeInKB", {
        get: function () {
            return Math.round(this._size / Download_1.KB_IN_BYTES);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "isImage", {
        get: function () {
            var _this = this;
            var imageTypes = ["bmp", "gif", "img", "jpe", "jpeg", "jpg", "mac", "pbm", "pct", "png", "ppm", "psd", "tiff"];
            return imageTypes.some(function (value) { return (_this._name).toLowerCase().endsWith(value); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "date", {
        get: function () {
            return this._date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "userName", {
        get: function () {
            return this._userName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "imageUrl", {
        get: function () {
            return this._imageUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Download.prototype, "errorMessage", {
        get: function () {
            return this._errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Download.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    Download.KB_IN_BYTES = 1024;
    Download.FILE_NOT_FOUND = "document.service.errors.file_not_found";
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Download.prototype, "documentId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Download.prototype, "height", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Download.prototype, "documentRootName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Download.prototype, "categorySystemName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Download.prototype, "entityId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Download.prototype, "documentPreviewEnabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Download.prototype, "showUploadDate", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Download.prototype, "showDocumentSize", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Download.prototype, "showUploadedBy", void 0);
    Download = Download_1 = __decorate([
        core_1.Component({
            
            selector: "sis-download",
            styles: [require('./sis-download.component.css')],
            template: require('./sis-download.component.html')
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: "Controls",
                    name: "Controls",
                },
            ],
            template: "\n        <sis-download class=\"sis-download-control\"\n                    [documentId]=\"%{documentId}\"\n                    [height]=\"%{height}\"\n                    [documentRootName]=\"%{documentRootName}\"\n                    [categorySystemName]=\"%{categorySystemName}\"\n                    [entityId]=\"%{entityId}\"\n                    [documentPreviewEnabled]=\"%{documentPreviewEnabled}\"\n                    [showUploadDate]=\"%{showUploadDate}\"\n                    [showDocumentSize]=\"%{showDocumentSize}\"\n                    [showUploadedBy]=\"%{showUploadedBy}\">\n        </sis-download>",
            iconInfo: "fa-caret-square-o-down",
            name: "Download",
        }),
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [document_service_1.DocumentService,
            idm_message_language_service_client_js_1.MessageService,
            idm_classifier_service_client_js_1.ClassifierService,
            document_auth_provider_service_1.DocumentAuthProviderService])
    ], Download);
    return Download;
    var Download_1;
}());
exports.Download = Download;
//# sourceMappingURL=sis-download.component.js.map